import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {HotelSearchRestrictions, OrganizationParameter, Restrictions, TourvisioRentingAgencyRestrictions} from '../../../utils/objects/organization-parameter';
import {ApiService} from '../../../utils/services/api.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {OrganizationParameterValue } from '../organization-parameter/organization-parameter.component';
import {RESTRICTION_PARAMETERS} from '../../../utils/constants/constants';

@Injectable()
export class ParameterResolverService implements Resolve<any> {
  private restrictions: Restrictions;
  constructor(private apiService: ApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    let organizationID = route.parent.params.id;
    let providers = [];
    this.restrictions = null;

    return this.apiService.getOrganizationParameters(organizationID).map(
      response => {
        let organizationParameterValue= new OrganizationParameterValue();
        response['data'].rows.forEach(
          (organizationParameter: OrganizationParameter) => {
            switch (organizationParameter.type) {
              case 'Currency':
                organizationParameterValue.currency = organizationParameter;
                break;
              case 'LowestLogicalFare':
                if (organizationParameter.context === 'International') {
                  if (organizationParameter.key === 'timeWindow') {
                    organizationParameterValue.internationalTimeWindow = organizationParameter;
                  } else if (organizationParameter.key === 'maxStops') {
                    organizationParameterValue.internationalMaxStops = organizationParameter;
                  }
                } else if (organizationParameter.context === 'Domestic') {
                  if (organizationParameter.key === 'timeWindow') {
                    organizationParameterValue.domesticTimeWindow = organizationParameter;
                  } else if (organizationParameter.key === 'maxStops') {
                    organizationParameterValue.domesticMaxStops = organizationParameter;
                  }
                }
                break;

              case 'PolicyReasonCode':
                organizationParameterValue.policyReasonCodes.push(organizationParameter);
                break;
              case 'TravelDeclineReasonCode':
                organizationParameterValue.travelDeclineReasonCodes.push(organizationParameter);
                break;
              case 'JustificationReasonCode':
                organizationParameterValue.justificationReasonCodes.push(organizationParameter);
                break;
              case RESTRICTION_PARAMETERS.type:
                this.setRestrictions(organizationParameter);
                break;
            }
          }
        );
        this.fillOrganizationRestrictionParameters(organizationParameterValue);
        return organizationParameterValue;
      }).catch((error) => {
      return Observable.of([]);
    });

  }

  setRestrictions (organizationParameter) {
    if(!this.restrictions)
      this.restrictions = new Restrictions();
    switch(organizationParameter.context){
      case RESTRICTION_PARAMETERS.context.hotelSearch:
        if(!this.restrictions.hotelSearch) {
          this.restrictions.hotelSearch = new HotelSearchRestrictions();
        }
        switch(organizationParameter.key) {
          case RESTRICTION_PARAMETERS.keys.hotelSearch.currency:
            this.restrictions.hotelSearch.currency = organizationParameter;
            break;
          case RESTRICTION_PARAMETERS.keys.hotelSearch.country:
            this.restrictions.hotelSearch.country = organizationParameter;
            break;
          case RESTRICTION_PARAMETERS.keys.hotelSearch.day:
            this.restrictions.hotelSearch.day = organizationParameter;
            break;
        }
        break;
      case RESTRICTION_PARAMETERS.context.secondBillingAddress:
        if(!this.restrictions.secondBillingAddress) {
          this.restrictions.secondBillingAddress = organizationParameter;
        }
        break;
      case RESTRICTION_PARAMETERS.context.integrationReportPurchaseRow:
        if(!this.restrictions.integrationReportPurchaseRow) {
          this.restrictions.integrationReportPurchaseRow = organizationParameter;
        }
        break;
      case RESTRICTION_PARAMETERS.context.mailOrder:
        if(!this.restrictions.mailOrder) {
          this.restrictions.mailOrder = organizationParameter;
        }
        break;
      case RESTRICTION_PARAMETERS.context.searchPriority:
        if(!this.restrictions.searchPriority) {
          this.restrictions.searchPriority = organizationParameter;
        }
        break;
      case RESTRICTION_PARAMETERS.context.tourvisioRentingAgency:
        if(!this.restrictions.tourvisioRentingAgency) {
          this.restrictions.tourvisioRentingAgency = new TourvisioRentingAgencyRestrictions();
        }
        switch(organizationParameter.key) {
          case RESTRICTION_PARAMETERS.keys.tourvisioRentingAgency.restrictedOfferTypes:
            this.restrictions.tourvisioRentingAgency.restrictedOfferTypes = organizationParameter;
            break;
        }
        break;
     }
  }

  fillOrganizationRestrictionParameters (organizationParameterValue) {
    if (!this.restrictions || !(this.restrictions.hotelSearch 
      || this.restrictions.secondBillingAddress 
      || this.restrictions.integrationReportPurchaseRow
      || this.restrictions.searchPriority
      || this.restrictions.mailOrder
      || this.restrictions.tourvisioRentingAgency)) {
      return;
    }

    organizationParameterValue.restrictions = new Restrictions();

    if (this.restrictions.hotelSearch 
      && this.restrictions.hotelSearch.currency 
      && this.restrictions.hotelSearch.day 
      && this.restrictions.hotelSearch.country) {

      organizationParameterValue.restrictions.hotelSearch = new HotelSearchRestrictions();

      organizationParameterValue.restrictions.hotelSearch.currency = this.restrictions.hotelSearch.currency;
      organizationParameterValue.restrictions.hotelSearch.day = this.restrictions.hotelSearch.day;
      organizationParameterValue.restrictions.hotelSearch.country = this.restrictions.hotelSearch.country;

    }
    if(this.restrictions.secondBillingAddress){
      organizationParameterValue.restrictions.secondBillingAddress = this.restrictions.secondBillingAddress;
    }
    if(this.restrictions.integrationReportPurchaseRow){
      organizationParameterValue.restrictions.integrationReportPurchaseRow = this.restrictions.integrationReportPurchaseRow;
    }
    if(this.restrictions.searchPriority){
      organizationParameterValue.restrictions.searchPriority = this.restrictions.searchPriority;
    }
    if(this.restrictions.tourvisioRentingAgency && this.restrictions.tourvisioRentingAgency.restrictedOfferTypes){
      organizationParameterValue.restrictions.tourvisioRentingAgency = this.restrictions.tourvisioRentingAgency;
    }
    if(this.restrictions.mailOrder){
      organizationParameterValue.restrictions.mailOrder = this.restrictions.mailOrder;
    }
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/resolvers/parameter-resolver.service.ts